import { AppBar, Box, Container, Stack } from '@mui/material';

import Logo from 'components-new/common/logo';
import NavDesktop from './NavDesktop';
import NavMobile from './NavMobile';
import ShareButtons from './ShareButtons';

type Props = {
  whitelabel: any;
  setSection: (section: string) => void;
  isDesktop: boolean;
  hasFloorPlans: boolean;
  translation: Record<string, string>;
};

export default function Navbar({ whitelabel, setSection, isDesktop, hasFloorPlans, translation }: Props) {
  const [overview, gallery, tour, floorPlans, contact] = [
    { key: 'Overview', label: translation.overview },
    { key: 'Gallery', label: translation?.gallery },
    { key: '3D Tour', label: translation?.threeDTour },
    { key: 'Floor Plans', label: translation?.floorPlans },
    { key: 'Contact', label: translation?.contact },
  ];

  const pages = hasFloorPlans ? [overview, gallery, tour, floorPlans, contact] : [overview, gallery, tour, contact];

  return (
    <AppBar
      sx={{
        background: '#fff',
        opacity: 1,
        top: 0,
        zIndex: 999,
        justifyContent: 'center',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
      }}
    >
      <Container
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <Logo href={whitelabel?.website} src={whitelabel?.logo} />
        <Box sx={{ flexGrow: 1 }} />
        {isDesktop && <NavDesktop setSection={setSection} pages={pages} />}
        <Box sx={{ flexGrow: 1 }} />
        <Stack spacing={2} direction="row" alignItems="center">
          {isDesktop && <ShareButtons />}
        </Stack>

        {!isDesktop && <NavMobile whitelabel={whitelabel} pages={pages} setSection={setSection} />}
      </Container>
    </AppBar>
  );
}
